import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PaymentHandlingDescription from './../_descriptions/PrimerPaymentHandlingDescriptionIos.mdx';
import ManualFlowDescription from './../_descriptions/ManualFlowDescriptionIos.mdx';
import LanguageCodeDescription from './../_descriptions/LanguageCodeDescriptionIos.mdx';
import RegionCodeDescription from './../_descriptions/RegionCodeDescriptionIos.mdx';
import UrlSchemeDescription from './../_descriptions/UrlSchemeDescriptionIos.mdx';
import ApplePayDescription from './../_descriptions/ApplePayDescriptionIos.mdx';
import CaptureBillingAddressDescription from './../_descriptions/CaptureBillingAddressDescriptionIos.mdx';
import ApplePayUnsupportedDeviceDescription from './../_descriptions/ApplePayForUnsupportedDevice.mdx';
import ApplePayCheckNetworksDescription from './../_descriptions/ApplePayCheckNetworks.mdx';
import KlarnaDescription from './../_descriptions/KlarnaDescriptionIos.mdx';
import UiOptionsDescription from './../_descriptions/UiOptionsDescriptionIos.mdx';
import InitScreenEnabledDescription from './../_descriptions/InitScreenEnabledDescriptionIos.mdx';
import SuccessScreenEnabledDescription from './../_descriptions/SuccessScreenEnabledDescriptionIos.mdx';
import ErrorScreenEnabledDescription from './../_descriptions/ErrorScreenEnabledDescriptionIos.mdx';
import ThreeDsOptionsIos from './../_descriptions/ThreeDsOptionsIos.mdx';
import StripeOptionsIoS from './../_descriptions/StripeOptionsIos.mdx';
import ApplePayMerchantNameIOS from './../_descriptions/ApplePayMerchantNameIOS.mdx';
import ClientSessionCachingEnabled from './../_descriptions/ClientSessionCachingEnabled.mdx';
import PrimerApiVersionDescription from './../_descriptions/PrimerApiVersionDescription.mdx';
import DropInDismissalMechanismDescription from '../_descriptions/DropInDismissalMechanismDescription.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Group summary='properties' open mdxType="Group">
	<Item title='paymentHandling' subtitle='enum PrimerPaymentHandling' mdxType="Item">
		<PaymentHandlingDescription mdxType="PaymentHandlingDescription" />
		<Group summary='cases' open mdxType="Group">
			<Item title='auto' subtitle='default' mdxType="Item">
				{'Primer SDK will create the payment and handle the flow.'}
			</Item>
			<Item title='manual' mdxType="Item">
				<ManualFlowDescription mdxType="ManualFlowDescription" />
			</Item>
		</Group>
	</Item>
	<Item title='localeData' subtitle='PrimerLocaleData' mdxType="Item">
		{"Forces some payment methods' locale."}
		<Group summary='properties' open mdxType="Group">
			<Item title='languageCode' subtitle='String' label='Required' mdxType="Item">
				<LanguageCodeDescription mdxType="LanguageCodeDescription" />
			</Item>
			<Item title='regionCode' subtitle='String' mdxType="Item">
				<RegionCodeDescription mdxType="RegionCodeDescription" />
			</Item>
		</Group>
	</Item>
	<Item title='paymentMethodOptions' subtitle='PrimerPaymentMethodOptions' mdxType="Item">
		<Group summary='properties' open mdxType="Group">
			<Item title='urlScheme' subtitle='String' mdxType="Item">
				<UrlSchemeDescription mdxType="UrlSchemeDescription" />
			</Item>
			<Item title='applePayOptions' subtitle='PrimerApplePayOptions' mdxType="Item">
				<ApplePayDescription mdxType="ApplePayDescription" />
				<Group summary='properties' open mdxType="Group">
					<Item title='merchantIdentifier' subtitle='String' label='Required' mdxType="Item">
						{'Set it to the merchant identifier as it is shown in your Apple Pay certificate.'}
					</Item>
					<ApplePayMerchantNameIOS mdxType="ApplePayMerchantNameIOS" />
					<Item title='isCaptureBillingAddressEnabled' subtitle='Bool' mdxType="Item">
						<CaptureBillingAddressDescription mdxType="CaptureBillingAddressDescription" />
						{'Deprecated: Use BillingOptions to configure required billing fields.'}
					</Item>
					<Item title='showApplePayForUnsupportedDevice' subtitle='Bool' mdxType="Item">
						<ApplePayUnsupportedDeviceDescription mdxType="ApplePayUnsupportedDeviceDescription" />
						{'Default value is `true`. Set to `false` if you do not want to present Apple Pay option on unsupported devices.'}
					</Item>
					<Item title='checkProvidedNetworks' subtitle='Bool' mdxType="Item">
						<ApplePayCheckNetworksDescription mdxType="ApplePayCheckNetworksDescription" />
						{'Default value is `true`. This flag supports the old behavior where Apple Pay flow might not present if there are no cards in the Wallet.'}
					</Item>
					<Item title='shippingOptions' subtitle='ShippingOptions' mdxType="Item">
						{'Configure shipping options for Apple Pay.'}
						<Group summary='properties' open mdxType="Group">
							<Item title='shippingContactFields' subtitle='Array of RequiredContactField' mdxType="Item">
								{'Specify which contact fields are required for shipping.'}
							</Item>
							<Item title='requireShippingMethod' subtitle='Bool' mdxType="Item">
								{'Indicate if a shipping method is required.'}
							</Item>
						</Group>
					</Item>
					<Item title='billingOptions' subtitle='BillingOptions' mdxType="Item">
						{'Configure billing options for Apple Pay.'}
						<Group summary='properties' open mdxType="Group">
							<Item title='requiredBillingContactFields' subtitle='Array of RequiredContactField' mdxType="Item">
								{'Specify which contact fields are required for billing.'}
							</Item>
						</Group>
					</Item>
				</Group>
			</Item>
			<Item title='klarnaOptions' subtitle='PrimerKlarnaOptions' mdxType="Item">
				<KlarnaDescription mdxType="KlarnaDescription" />
				<Group summary='properties' open mdxType="Group">
					<Item title='recurringPaymentDescription' subtitle='String' label='Required' mdxType="Item">
						{'Set the payment description that will be shown on the Klarna screen.'}
					</Item>
				</Group>
			</Item>
			<Item title='threeDsOptions' subtitle='PrimerThreeDsOptions' mdxType="Item">
				<Group summary='properties' open mdxType="Group">
					<ThreeDsOptionsIos mdxType="ThreeDsOptionsIos" />
				</Group>
			</Item>
			<Item title='stripeOptions' subtitle='PrimerStripeOptions' mdxType="Item">
				⚠️ Required when using Stripe ACH in your integration.
				<Group open summary='Properties' mdxType="Group">
					<StripeOptionsIoS mdxType="StripeOptionsIoS" />
				</Group>
			</Item>
		</Group>
	</Item>
	<Item title='uiOptions' subtitle='PrimerUIOptions' mdxType="Item">
		<UiOptionsDescription mdxType="UiOptionsDescription" />
		<Group summary='properties' open mdxType="Group">
			<Item title='isInitScreenEnabled' subtitle='Bool' mdxType="Item">
				<InitScreenEnabledDescription mdxType="InitScreenEnabledDescription" />
			</Item>
			<Item title='isSuccessScreenEnabled' subtitle='Bool' mdxType="Item">
				<SuccessScreenEnabledDescription mdxType="SuccessScreenEnabledDescription" />
			</Item>
			<Item title='isErrorScreenEnabled' subtitle='Bool' mdxType="Item">
				<ErrorScreenEnabledDescription mdxType="ErrorScreenEnabledDescription" />
			</Item>
			<Item title='dismissalMechanism' subtitle='enum DismissalMechanism' mdxType="Item">
				<DropInDismissalMechanismDescription mdxType="DropInDismissalMechanismDescription" />
			</Item>
			<Item title='theme' subtitle='PrimerTheme' mdxType="Item">
				{'Set a custom theme for Primer SDK.'}
			</Item>
			<Item title='cardFormUIOptions' subtitle='PrimerCardFormUIOptions?' mdxType="Item">
				Configure the card form UI options.
				<Group summary='properties' open mdxType="Group">
					<Item title='payButtonAddNewCard' subtitle='Bool' mdxType="Item">
						When set to true, the Drop-In's card form pay button will show "Add new card"; otherwise it will show "Pay $x.xx".
					</Item>
				</Group>
			</Item>
		</Group>
	</Item>
	<Item title='debugOptions' subtitle='PrimerDebugOptions' mdxType="Item">
		<Group summary='properties' open mdxType="Group">
			<Item title='is3DSSanityCheckEnabled' subtitle='Bool' label='Required' mdxType="Item"></Item>
		</Group>
	</Item>
	<Item title='clientSessionCachingEnabled' subtitle='Bool' label='Default: false' mdxType="Item">
		<ClientSessionCachingEnabled mdxType="ClientSessionCachingEnabled" />
	</Item>
  <Item title='apiVersion' subtitle='PrimerApiVersion' label='Default: PrimerApiVersion.V2_4' mdxType="Item">
    <PrimerApiVersionDescription mdxType="PrimerApiVersionDescription" />
  </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      